
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

const tabValues = [
    {
        id: "1",
        name: "Pages",
    },
    {
        id: "2",
        name: "Features",
    },
    {
        id: "3",
        name: "Styles",
    },
    {
        id: "4",
        name: "Preset Styles",
    }
]

const TabItem = ({ id, name, onClick, activeTab }) => {
    return (
        <NavItem>
            <NavLink className={classnames({ active: activeTab === id })} onClick={() => { onClick(id) }}>
                {name}
            </NavLink>
        </NavItem>
    )
}

export const Tabs = ({ onClickTab, activeTab }) => {
    return (
        <Nav tabs>
            {tabValues.map(val =>
                <TabItem key={val.id} id={val.id} name={val.name} onClick={onClickTab} activeTab={activeTab} />
            )}
        </Nav>
    )
}
